exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nstrong[data-v-00b6cf0d] {\n     color: #FFF !important;\n}\n.breadcrumb a[data-v-00b6cf0d] {\n    align-items: center;\n    color: rgb(72 95 199) !important;\n}\n", ""]);

// exports
